document.documentElement.classList.remove("no-js");

const toggleHidden = (element, open) => {
  if (!element) return;
  element.hidden = !open;
};

document.addEventListener("click", (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const menu = document.querySelector("[data-mobile-menu]");
  const search = document.querySelector("[data-search-panel]");
  if (target.closest("[data-menu-toggle]")) {
    toggleHidden(menu, true);
    document.body.classList.add("menu-open");
  }
  if (target.closest("[data-menu-close]")) {
    toggleHidden(menu, false);
    document.body.classList.remove("menu-open");
  }
  if (target.closest("[data-search-toggle]")) {
    toggleHidden(search, true);
    search?.querySelector("input")?.focus();
  }
  if (target.closest("[data-search-close]")) toggleHidden(search, false);
});

document.addEventListener("submit", async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches(".quick-add")) return;
  event.preventDefault();
  const button = form.querySelector("button");
  if (button) button.disabled = true;
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form),
    });
    if (!response.ok) throw new Error("Cart error");
    const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((result) =>
      result.json(),
    );
    document.querySelectorAll("[data-cart-count]").forEach((node) => {
      node.textContent = cart.item_count;
    });
    const toast = document.querySelector("[data-cart-toast]");
    if (toast) {
      toast.textContent = "Prodotto aggiunto al carrello";
      toast.classList.add("is-visible");
      window.setTimeout(() => toast.classList.remove("is-visible"), 2200);
    }
  } catch {
    window.location.href = form.action;
  } finally {
    if (button) button.disabled = false;
  }
});

// Regia condivisa per tutte le scene scroll-driven della homepage.
// Desktop: scena sticky e camera 3D. Mobile: flusso naturale con movimento ridotto.
const ongameMotion = (() => {
  const scenes = [...document.querySelectorAll("[data-cine]")];
  const hero = document.querySelector("[data-ong-hero]");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let ticking = false;

  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const mix = (a, b, p) => a + (b - a) * p;
  const phase = (p) => (p < 0.5 ? p * 2 : (p - 0.5) * 2);

  const cameraFor = (kind, p) => {
    const exit = p > 0.5;
    const q = phase(p);
    const values = {
      tcg: exit ? [0, 17, 0, -22, 0, 9, 0, 6, 1.08, 0.9] : [-13, 0, 30, 0, -13, 0, -9, 0, 0.78, 1.08],
      funko: exit ? [0, 12, 2, -18, 0, -5, 0, -4, 1.06, 0.94] : [-4, 0, 22, 2, 9, 0, 4, 0, 0.82, 1.06],
      statue: exit ? [0, -9, -2, -24, 0, -4, 0, 0, 1.03, 0.92] : [7, 0, 22, -2, 6, 0, 0, 0, 0.86, 1.03],
      gaming: exit ? [0, 10, 2, 18, 0, -5, 0, 8, 1.06, 0.92] : [-8, 0, -20, 2, 8, 0, -8, 0, 0.84, 1.06],
      katana: [-22, 18, 0, 0, 0, 0, -6, 4, 1, 1],
    }[kind] || [0, 0, 0, 0, 0, 0, 0, 0, 1, 1];
    return {
      x: mix(values[0], values[1], q), ry: mix(values[2], values[3], q),
      rx: mix(values[4], values[5], q), rz: mix(values[6], values[7], q),
      scale: mix(values[8], values[9], q),
    };
  };

  const update = () => {
    ticking = false;
    const mobile = window.innerWidth <= 700;
    const reduced = reduceMotion.matches;
    if (hero) {
      const rect = hero.getBoundingClientRect();
      const hp = clamp(-rect.top / Math.max(1, rect.height));
      const card = hero.querySelector(".ong-hero__object--card");
      if (card && !reduced) {
        const amount = mobile ? 0.3 : 1;
        card.style.translate = `0 ${-38 * hp * amount}%`;
        card.style.rotate = `${-8 * hp * amount}deg`;
        card.style.scale = `${1 + 0.12 * hp * amount}`;
      }
    }
    scenes.forEach((scene) => {
      const rect = scene.getBoundingClientRect();
      const p = clamp((window.innerHeight - rect.top) / (window.innerHeight + rect.height));
      scene.style.setProperty("--p", p.toFixed(4));
      if (mobile) {
        const reveal = clamp((window.innerHeight * 0.9 - rect.top) / (window.innerHeight * 0.52));
        scene.style.setProperty("--mobile-reveal", reveal.toFixed(4));
      }
      const kind = scene.dataset.cine;
      const art = scene.querySelector("[data-cine-art]");
      if (art && !reduced) {
        const c = cameraFor(kind, p);
        if (mobile) {
          art.style.setProperty("--mobile-y", `${mix(14, -10, p) * 0.75}%`);
          art.style.setProperty("--mobile-rx", `${c.rx * 0.55}deg`);
          art.style.setProperty("--mobile-ry", `${c.ry * 0.55}deg`);
          art.style.setProperty("--mobile-rz", `${c.rz * 0.55}deg`);
          art.style.setProperty("--mobile-s", `${mix(0.91, 1.04, 1 - Math.abs(p - 0.5) * 2)}`);
        } else {
          art.style.transform = `translate3d(${c.x}%,${mix(7,-6,p)}%,${mix(-180,80,1-Math.abs(p-.5)*2)}px) rotateX(${c.rx}deg) rotateY(${c.ry}deg) rotateZ(${c.rz}deg) scale(${c.scale})`;
        }
      }
      const bricks = scene.querySelectorAll(".ong-brick");
      bricks.forEach((brick, index) => {
        if (reduced) return;
        const spread = mobile ? 42 : 95;
        const settle = 1 - Math.abs(p - 0.58) * 1.7;
        brick.style.translate = `${Math.cos(index * 1.7) * spread * (1 - settle)}px ${Math.sin(index * 1.3) * spread * (1 - settle)}px`;
        brick.style.rotate = `${mix(-16, 8, p) * (index % 2 ? -1 : 1)}deg`;
      });
    });
  };
  const requestUpdate = () => {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  };
  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", requestUpdate, { passive: true });
  document.addEventListener("shopify:section:load", requestUpdate);
  requestUpdate();
  return { update: requestUpdate };
})();

// Filtri catalogo condivisi da tutte le pagine di sottocategoria.
// Per disponibilità e offerte raccoglie anche le pagine successive della collezione.
const initCatalogFilters = () => {
  document.querySelectorAll("[data-catalog-filter-form]").forEach(async (form) => {
    const grid = document.querySelector("[data-product-grid]");
    if (!(form instanceof HTMLFormElement) || !(grid instanceof HTMLElement)) return;

    const params = new URLSearchParams(window.location.search);
    const availableOnly = params.get("ong_available") === "1";
    const saleOnly = params.get("ong_sale") === "1";
    const sortBy = params.get("sort_by") || "";
    const availableInput = form.elements.namedItem("ong_available");
    const saleInput = form.elements.namedItem("ong_sale");
    const sortInput = form.elements.namedItem("sort_by");
    const status = document.querySelector("[data-catalog-filter-status]");

    if (availableInput instanceof HTMLInputElement) availableInput.checked = availableOnly;
    if (saleInput instanceof HTMLInputElement) saleInput.checked = saleOnly;
    if (sortInput instanceof HTMLSelectElement) sortInput.value = sortBy;
    const totalPages = Math.max(1, Number(grid.dataset.totalPages) || 1);
    const currentPage = Math.max(1, Number(grid.dataset.currentPage) || 1);
    const matches = (card) => {
      const availableMatch = !availableOnly || card.dataset.available === "true";
      const saleMatch = !saleOnly || card.dataset.sale === "true";
      return availableMatch && saleMatch;
    };
    const cards = [...grid.querySelectorAll("[data-product-card]")].filter(matches);

    grid.setAttribute("aria-busy", "true");
    if (status) status.textContent = "Aggiornamento prodotti…";

    try {
      for (let page = 1; page <= totalPages; page += 1) {
        if (page === currentPage) continue;
        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set("page", String(page));
        const response = await fetch(pageUrl, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (!response.ok) continue;
        const html = await response.text();
        const pageDocument = new DOMParser().parseFromString(html, "text/html");
        pageDocument.querySelectorAll("[data-product-grid] [data-product-card]").forEach((card) => {
          if (card instanceof HTMLElement && matches(card)) cards.push(card);
        });
      }

      cards.sort((first, second) => {
        const firstAvailable = first.dataset.available === "true";
        const secondAvailable = second.dataset.available === "true";
        return Number(secondAvailable) - Number(firstAvailable);
      });

      if (cards.length) {
        grid.replaceChildren(...cards);
      } else {
        const empty = document.createElement("p");
        empty.className = "catalog-filter-empty";
        empty.textContent = "Nessun prodotto corrisponde ai filtri selezionati.";
        grid.replaceChildren(empty);
      }
      document.querySelector(".collection-main .pagination")?.remove();
      if (status) {
        status.textContent = `${cards.length} ${cards.length === 1 ? "prodotto trovato" : "prodotti trovati"}`;
      }
    } catch {
      if (status) status.textContent = "Impossibile aggiornare tutti i prodotti. Riprova.";
    } finally {
      grid.removeAttribute("aria-busy");
    }
  });
};

initCatalogFilters();
